import React from 'react';
import StyleButton from './StyleButton';

const BLOCK_TYPES = [
    { label: 'Unordered list', style: 'unordered-list-item', icon: 'list-ul' },
    { label: 'Ordered list', style: 'ordered-list-item', icon: 'list-ol' }
];

const BlockStyleControls = ({ onToggle, editorState }) => {
    const selection = editorState.getSelection();
    const blockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();

    return (
        <div>
            {BLOCK_TYPES.map(type => {
                return (
                    <StyleButton
                        key={type.label}
                        active={type.style === blockType}
                        label={type.label}
                        onToggle={onToggle}
                        style={type.style}
                        icon={type.icon}
                    />
                );
            })}
        </div>
    );
};

export default BlockStyleControls;
